import { numberFormatter } from '../../../../Utils/Formatters'
import {
  dropTimeZoneFromDate,
  getWeekNumberAndYear,
} from '../../../../shared/libraries/utils/date'
import { isDefined } from '../../../../shared/libraries/utils/object'

/**
 * Local util for formatting pack size
 * @param {number} packSize
 * @param {number} householdsAmount
 * @returns {string} Pack size or approx pack size
 */
const _getPackSize = (packSize, householdsAmount) => {
  if (packSize && !isNaN(packSize)) {
    return packSize
  }
  if (householdsAmount && !isNaN(householdsAmount)) {
    if (householdsAmount > 200) {
      return `Apx. ${Math.floor(householdsAmount / 100) * 100}`
    } else {
      return `Apx. ${householdsAmount}`
    }
  }

  return '-'
}
/**
 * Formats data for table comsumption
 * @param {array} Missions
 * @returns {array} Array of object where keys are table columns names
 * @example formatData([{ id: 100023, status: 'AVAILABLE', density: 52, householdsAmount: 923, dateTime: ISO }])
 */
export const formatData = missions =>
  missions.map(mission => {
    const { weekNumber, year } = getWeekNumberAndYear(
      new Date(dropTimeZoneFromDate(mission.dateTime)),
    )

    return {
      id: mission.id,
      'Status': mission.status,
      'Density': mission.density,
      'Addresses': mission.householdsAmount,
      'Flyer Code': mission.flyerCode,
      'Flyers Distributed': mission.totalFlyersDistributed,
      'Pack Size': _getPackSize(mission.packSize, mission.householdsAmount),
      'Pay Adjustment': isDefined(mission.draftPayAdjustment)
        ? `${mission.draftPayAdjustment / 100}`
        : '-',
      'Cost Per Flyer': mission.costPerFlyer ? mission.costPerFlyer : '-',
      'Week': `W${weekNumber}, ${year}`,
      'Date': mission.dateTime,
      'BA': mission.user
        ? mission.user.firstName + ' ' + mission.user.lastName
        : null,
      userId: mission.user && mission.user.id,
      cityId: mission.city && mission.city.id,
      label: mission.label,
      cancelled: mission.cancelled,
    }
  })

/**
 * Formats data for table comsumption, counts totals for specific columns
 * @param {array} Missions
 * @returns {array} Array of object where keys are table columns names
 * @example getFooterData([{ density: 52, householdsAmount: 923 }])
 */
export const getFooterData = missions => {
  const { totalAddresses, totalDensity } = missions.reduce(
    (acc, mission) => {
      const density = Number(mission['Density'])
      const addresses = Number(mission['Addresses'])
      acc.totalDensity += isNaN(density) ? 0 : density
      acc.totalAddresses += isNaN(addresses) ? 0 : addresses
      return acc
    },
    {
      totalAddresses: 0,
      totalDensity: 0,
    },
  )

  const data = {
    'Select': 'Total:',
    'Label': numberFormatter(missions.length),
    'Density': numberFormatter(totalDensity),
    'Addresses': numberFormatter(totalAddresses),
  }

  return [data]
}



// WEBPACK FOOTER //
// ./src/Containers/LetterboxMissions/blocks/LetterboxMissionsTable/util.js